import { Alert } from "components/alert";
import { useEffect, useMemo, useRef } from "react";
import { RequestTopics } from "services/topics";
import { useStore } from "hooks/use-store";
import { Color } from "utils/theme";
import { ScrollButtons } from "components/ui/scroll-buttons";
import { toast } from "react-toastify";
import useMqttApi from "hooks/use-mqtt-api";
import { Alert as IAlert } from "types/alert";
import { formatAlert } from "./utils";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/ui/spinner";

export const AlertsScreen = () => {
  const alert = useStore((state) => state.alert);
  const config = useStore((state) => state.config);
  const { t } = useTranslation();

  const resetAlertCounter = useStore((state) => state.resetAlertCounter);
  const ref = useRef<HTMLDivElement>(null);

  const {
    data: alerts,
    loading,
    fetch,
  } = useMqttApi<{ data: IAlert[] }>({
    requestTopic: RequestTopics.Alerts,
    enabled: true,
    onError: (error) => toast.error(error.message),
  });

  useEffect(() => {
    resetAlertCounter();
    if (alert) fetch();
  }, [alert]);

  const formattedAlerts = useMemo(() => {
    if (!alerts || !alerts?.data) return [];

    return (
      alerts.data?.map((alert) =>
        formatAlert(
          alert,
          config?.holy_books?.fields_bible || null,
          config?.geofences || []
        )
      ) || []
    );
  }, [alerts]);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!formattedAlerts?.length) {
    return (
      <div className="h-screen flex items-center justify-center text-lg">
        <p style={{ color: Color.Primary[400] }}>{t("alerts.no_alerts")}.</p>
      </div>
    );
  }

  return (
    <section className="h-screen overflow-hidden  flex flex-col w-full">
      <h2 className="text-2xl font-medium px-4 py-4 pb-1 tabular-nums">
        {t("alerts.title")} ({formattedAlerts.length})
      </h2>
      <div ref={ref} className="flex-1 pb-24 w-full overflow-y-auto">
        {formattedAlerts?.reverse()?.map((alert, index) => (
          <Alert key={index} alert={alert} />
        ))}
      </div>
      <ScrollButtons containerRef={ref} className="absolute bottom-4 right-4" />
    </section>
  );
};
